export const BASE_URL = process.env.REACT_APP_API_URL;
export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const passwordPattern = /^(?=.*[A-Z])(?=.*[^A-Za-z0-9]).{8,}$/;

/**
 * Admin API URL - Single deployment that serves both stage and prod.
 * Environment is selected via X-Environment header, not different URLs.
 * 
 * In production, REACT_APP_API_URL should be set to https://admin-api.dataryx.ai
 * For local development, it defaults to http://localhost:8001
 */
const getApiUrl = (): string => {
    // Check if we have an env var set
    if (process.env.REACT_APP_API_URL) {
        return process.env.REACT_APP_API_URL;
    }
    // In production (HTTPS), use the production API
    if (typeof window !== 'undefined' && window.location.protocol === 'https:') {
        return 'https://admin-api.dataryx.ai';
    }
    // Local development fallback
    return 'http://localhost:8001';
};

export const ADMIN_API_URL = getApiUrl();

/**
 * Legacy backend URLs - kept for backwards compatibility.
 * @deprecated Use ADMIN_API_URL with X-Environment header instead.
 */
export const BACKENDS = {
    stage: 'https://api.stage.dataryx.ai',
    live: 'https://api.dataryx.ai',
    local: 'http://localhost:8001',
};

/**
 * Get the admin API URL.
 * Returns ADMIN_API_URL - environment is controlled via X-Environment header.
 */
export const getCurrentBackendUrl = (): string => {
    // Use the single admin API URL
    // Environment selection is now done via X-Environment header, not URL
    return ADMIN_API_URL;
};

/**
 * @deprecated Backend selection is replaced by environment selection.
 * Use the EnvironmentSelector component instead.
 */
export const setCurrentBackend = (backendKey: string): void => {
    localStorage.setItem('selectedBackend', backendKey);
    localStorage.setItem('lastUsedBackend', backendKey);
};

/**
 * Get the current environment for API requests.
 */
export const getCurrentEnvironment = (): 'local' | 'stage' | 'prod' => {
    const env = localStorage.getItem('admin_environment');
    if (env === 'local' || env === 'stage' || env === 'prod') {
        return env;
    }
    return 'local'; // Default to local for development
};
